import { Card, Flexbox } from '@/components'
import currency from '@/lib/masks/currency'
import PropTypes from 'prop-types'
import React from 'react'

export default function LowIncomeCard({ data }) {
  const { lowIncome } = data

  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h6 card-title">Dados de baixa renda</div>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-file" />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        <small>
          <Flexbox.Columns>
            <Flexbox.Column>
              Membros na família
            </Flexbox.Column>
            <Flexbox.Column className="col-auto">
              <b>{lowIncome?.numberOfFamilyMembers || '-'}</b>
            </Flexbox.Column>
          </Flexbox.Columns>
          <Flexbox.Columns>
            <Flexbox.Column>
              Renda familiar mensal
            </Flexbox.Column>
            <Flexbox.Column className="col-auto">
              <b>{currency(lowIncome?.familyIncome || 0, 'R$ ')}</b>
            </Flexbox.Column>
          </Flexbox.Columns>
          <Flexbox.Columns>
            <Flexbox.Column>
              Número do CRAS
            </Flexbox.Column>
            <Flexbox.Column className="col-auto">
              <b>{lowIncome?.cras || '-'}</b>
            </Flexbox.Column>
          </Flexbox.Columns>
          <Flexbox.Columns>
            <Flexbox.Column>
              Número do NIS
            </Flexbox.Column>
            <Flexbox.Column className="col-auto">
              <b>{lowIncome?.nis || '-'}</b>
            </Flexbox.Column>
          </Flexbox.Columns>
          <div className="divider text-center" data-content="Benefícios" />
          <div className="pre">
            {lowIncome?.benefitsReceived || '-'}
          </div>
          <div className="divider text-center" data-content="Outras informações" />
          <div className="pre">
            {lowIncome?.otherInformation || '-'}
          </div>
        </small>
      </Card.Body>
    </Card.Base>
  )
}

LowIncomeCard.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
}
